export default {
  routes: [
    {
      name: 'courses',
      path: '/directory/course',
      component: () => import('./views/TheCourses.vue'),

    },

    {
      name: 'course',
      path: '/directory/course/:uuid',
      component: () => import('./views/TheCourse.vue'),
    },
  ]
}
